// extracted by mini-css-extract-plugin
export default {"unitPrices":"unitPrices_unitPrices__3sl6Y","prices":"unitPrices_prices__b29tM","row":"unitPrices_row__rQOtN","label":"unitPrices_label__ejALf"};